import React from 'react'
import FrontendLayout from '../FrontendLayout'
import Hero from '../front-components/Hero'
import { ORG } from '../../data/costant'

export default function TermsShipping() {
  return (
    <FrontendLayout>
      <Hero title="Terms of Shipping" />
      <div className="container my-5 card">
        <div className="card-body">
          <h6>TERMS OF SHIPPING SERVICE</h6>
          <h6>{ORG.web} ({ORG.name})</h6>
          <p>
            This legal document is an electronic record in terms of the Information Technology Act, 2000 and rules thereunder, as applicable,
            including the amended provisions. This electronic record is generated by a computer system and does not require any physical or
            digital signatures.
          </p>

          <p>
            This document is published in accordance with Rule 3(1) of the Information Technology (Intermediaries Guidelines) Rules, 2011 and Rule 4
            of the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011,
            under the Information Technology Act, 2000 as amended. These rules require publishing the terms of services and practices for the access
            or usage of www.{ORG.web} and other integrated systems (“{ORG.web} ({ORG.name})”).
          </p>

          <p>
            These terms of services apply to all users who use {ORG.web} and its integrated systems. Users include service partners, their owners,
            managers, and staff members, as well as end users who connect with service partners for transportation needs. By using the web, clicking
            the “I accept/I agree” button, or completing the registration process, you agree to these terms of service.
          </p>

          <h6>Purpose</h6>
          <p>
            {ORG.web} serves as an intermediary between customers seeking truck/transport services and truck drivers/owners offering such services.
          </p>

          <h6>User Agreement</h6>
          <p>
            This agreement contains rules, regulations, policies, and terms applicable to any user of {ORG.web}. By accessing or using the web, you
            agree to be bound by these terms.
          </p>

          <h6>Amendment</h6>
          <p>
            By accepting this agreement, you also accept {ORG.web}'s rules and policies as updated from time to time.
          </p>

          <h6>Eligibility</h6>
          <ul>
            <li>Only persons capable of forming legally binding contracts under the Indian Contract Act, 1872, may access or use this web.</li>
            <li>Minors, persons of unsound mind, and insolvents are not eligible to use the web.</li>
            <li>Entities registering on the web must have legal authority to accept this agreement.</li>
          </ul>

          <h6>Registration and Communication</h6>
          <p>Registration</p>
          <ul>
            <li>You may register via Facebook, Google+, or email, granting {ORG.web} access to your profile details for registration purposes.</li>
            <li>You are responsible for maintaining the confidentiality of your login credentials and for all activities conducted under your account.</li>
            <li>Providing inaccurate or incomplete information may result in suspension or termination of your access.</li>
          </ul>
          <h6>Electronic Communication</h6>
          <p>
            You agree to receive all communications from {ORG.web} electronically and acknowledge that such communications constitute adequate notice.
          </p>

          <h6>Technical Requirements</h6>
          <ul>
            <li>Users must have the necessary technical requirements, including a PC/Tablet and broadband or 3G internet connectivity.</li>
            <li>Instructions on using {ORG.web} are available on the homepage and must be adhered to for proper access.</li>
          </ul>

          <h6>Payment</h6>
          <p>
            Payment plans, terms, and refund policies are outlined in Annexure-A. Payments must be made using authorized payment gateways, and the company
            is not responsible for delays or errors caused by external entities.
          </p>

          <h6>Services Activation and Delivery</h6>
          <ul>
            <li>After registration and payment, users will receive acknowledgment via email/SMS and services will be activated within 24 hours.</li>
            <li>{ORG.web} is not responsible for delays or connectivity issues during service delivery.</li>
          </ul>

          <h6>User Account and Security</h6>
          <ul>
            <li>You are responsible for the confidentiality of your account and for all activities under your account.</li>
            <li>Notify {ORG.web} immediately of any unauthorized use or breach of security.</li>
          </ul>
          <h6>User Obligations</h6>
          <div className="section">
            <h6>General Rules</h6>
            <ul>
              <li>Do not host, display, upload, modify, publish, transmit, or share any information that:
                <ul>
                  <li>Belongs to another person without their consent.</li>
                  <li>Is harmful, harassing, blasphemous, obscene, or otherwise unlawful.</li>
                  <li>Infringes intellectual property or violates privacy rights.</li>
                  <li>Contains viruses, Trojans, or other harmful code.</li>
                  <li>Threatens national security or public order.</li>
                </ul>
              </li>
              <li>Do not deceive, impersonate, or mislead users or entities.</li>
              <li>Refrain from unauthorized access to databases or information.</li>
            </ul>
          </div>

          <div className="section">
            <h6>Privacy of Data</h6>
            <p>All user data will be stored securely on the server. Users must review and agree to the platform's privacy policy.</p>
            <p>The company is not responsible for maintaining backups; users should ensure they have their own copies.</p>
          </div>

          <div className="section">
            <h6>Third-Party Links</h6>
            <p>Links to third-party websites are provided for convenience and accessed at the user's own risk. The company holds no responsibility for third-party policies or content.</p>
          </div>

          <div className="section">
            <h6>Content Management</h6>
            <ul>
              <li>Content is provided for reference and does not replace professional advice.</li>
              <li>Users should verify the accuracy of content independently.</li>
              <li>In case of inaccuracies, users are encouraged to notify the company with corrections.</li>
            </ul>
          </div>

          <div className="section">
            <h6>Indemnity</h6>
            <p>Users agree to indemnify the company against claims arising from breaches of this agreement, violations of laws, or third-party rights.</p>
          </div>

          <div className="section">
            <h6>Intellectual Property Rights (IPR)</h6>
            <ul>
              <li>Content rights belong to service partners. Other site elements are owned by the company.</li>
              <li>Users must not obscure or remove copyright notices.</li>
              <li>Claims of copyright violation require prior notification and resolution attempts.</li>
            </ul>
          </div>

          <div className="section">
            <h6>Compliance with IT Laws</h6>
            <ul>
              <li>Users must not use the platform for unlawful activities.</li>
              <li>Prohibited activities include:
                <ul>
                  <li>Introducing viruses, Trojans, or malware.</li>
                  <li>Promoting pornography or child pornography.</li>
                  <li>Performing web-jacking or other cyberattacks.</li>
                </ul>
              </li>
              <li>Violations may result in liability under the Indian IT Act, 2000.</li>
            </ul>
          </div>
          <ul>
            <li>
              <strong>Privacy of Data:</strong>
              <p>All details of {ORG.web} ({ORG.name}) will be stored securely on the web server. It is compulsory to refer and agree with our privacy policy and reasonable security practices & procedures.</p>
            </li>
            <li>
              <strong>Third Party Links:</strong>
              <ul>
                <li>We may choose from time to time to provide links to various third-party webs from the Web. This may include links to sites owned by our associated companies.</li>
                <li>These third-party links are provided for your convenience only and are accessed at your own risk.</li>
                <li>You agree that we have no responsibility or liability for any independent policies or actions of these third-party links and are not responsible in any way for the privacy practices, customer service practices, content, or availability of any such website.</li>
              </ul>
            </li>
            <li>
              <strong>Content:</strong>
              <ul>
                <li>Information, reports, videos, blogs, newsletters, and every other feature (Collectively known as “online contents”) may be added to and removed from the Service without notice.</li>
                <li>The online contents are provided for reference purposes only and are not intended as a substitute for professional advice or to provide legal or other advice with respect to particular circumstances.</li>
                <li>Reasonable care has been taken to ascertain the accuracy of all contents, but they are provided on an 'as is' basis with no warranties for fitness for a particular purpose.</li>
                <li>Users should obtain independent verification or advice before relying on any piece of information.</li>
              </ul>
            </li>
            <li>
              <strong>Indemnity:</strong>
              <p>You shall indemnify and hold harmless the Company and its affiliates from any claim, demand, or actions arising out of your breach of the User Agreement or your violation of any law or the rights of a third party.</p>
            </li>
            <li>
              <strong>Intellectual Property Rights (IPR):</strong>
              <ul>
                <li>All intellectual property rights in the online contents belong to the respective service partner who has uploaded them.</li>
                <li>Users shall not obscure or remove any copyright notices that appear on the online contents.</li>
                <li>The graphics, software, display formats, design, and interface of the website are owned by the company and protected under applicable laws.</li>
                <li>Users must follow the grievance procedure described in the intermediary compliance policy as per Section 79 of the I.T. Act, 2000.</li>
              </ul>
            </li>
            <li>
              <strong>Restrictions:</strong>
              <ul>
                <li>Users shall not re-sell the Service or any part of the contents.</li>
                <li>Users shall not make the Service or contents available to unauthorized persons.</li>
                <li>Users shall not download, store, reproduce, or use the web other than as permitted.</li>
                <li>Users shall not decompile or reverse engineer software programs used by the Service.</li>
                <li>Users shall not use the Service for illegal purposes or send defamatory, obscene, or unsolicited promotional material.</li>
              </ul>
            </li>
            <li>
              <strong>Termination of Services:</strong>
              <ul>
                <li>This Agreement shall commence on the Start Date and shall survive till terminated by the company via specific e-notice.</li>
                <li>The company may suspend the Service if the user is not complying with the Agreement.</li>
                <li>During suspension, the company has no obligation to reinstate the Service until disputed issues are resolved.</li>
              </ul>
            </li>
          </ul>
          <ul>
            <li><strong>Limited liability clause</strong>
              <ul>
                <li>You agree and acknowledge that in no event shall the Company or its directors, managers, staff members, affiliates, and service providers be liable for any direct, indirect, incidental, special, consequential, or exemplary damages, including but not limited to, damages for loss of profits, goodwill, use, data, or other intangible losses arising (in any manner whatsoever, including but not limited to negligence) out of or in connection with the web, the Pay Facility, or any other services under this Agreement.</li>
                <li>The Company’s liability in any circumstance is limited to the amount of charges/fees, if any, paid by you to the Company.</li>
                <li>Disputes between Truck Service Providers and End users relating to payments/services shall be governed by the Truck Service Provider’s policy only.</li>
                <li>Clients are encouraged to take suitable transport insurance for protection of the merchandise/item that the clients plan to ship.</li>
                <li>The maximum liability of the Company towards the user will be Rs.5000/- for full load and Rs.2500/- for part load or 10% of the total freight paid (excluding any taxes), whichever is lower.</li>
              </ul>
            </li>
            <li><strong>Modification and Amendments to Terms of Use</strong>
              <ul>
                <li>The Company has the right to make alterations and modifications to any information incorporated within this site without giving any prior notice.</li>
                <li>The Company reserves the right to alter any of the Terms of Use without prior notice.</li>
              </ul>
            </li>
            <li><strong>Breach</strong>
              <ul>
                <li>The Company may limit your activity, remove your information, suspend or terminate services, and/or refuse access to the Web in the event of breach of this agreement or related policies.</li>
                <li>Users who have been suspended or blocked may not register or attempt to register without reinstatement by the Company.</li>
              </ul>
            </li>
            <li><strong>Grievance Redressal Process</strong>
              <ul>
                <li>Users should promptly raise grievances with the designated Grievance Officer at <a href="mailto:info@Nexways.in">info@Nexways.in</a>.</li>
                <li>The name and contact details of the Grievance Officer are published on the Web as required under the Information Technology Act, 2000.</li>
              </ul>
            </li>
            <li><strong>Consent</strong>
              <ul>
                <li>The contracting parties give their consent freely, legally, and voluntarily to enter into this contract.</li>
              </ul>
            </li>
            <li><strong>Actions in Good Faith</strong>
              <ul>
                <li>All actions under this agreement are deemed to be in good faith unless evidence suggests otherwise.</li>
              </ul>
            </li>
            <li><strong>Language</strong>
              <ul>
                <li>All notices shall be in English.</li>
                <li>In case of inconsistency, the English version of the document is authoritative.</li>
              </ul>
            </li>
            <li><strong>Appropriation of Payments</strong>
              <ul>
                <li>Subsequent payments will fulfill the earliest outstanding debt in case of default on more than two occasions.</li>
              </ul>
            </li>
            <li><strong>Injunction</strong>
              <ul>
                <li>The Company shall be entitled to injunctive relief in the event of a breach, without proving actual damage.</li>
              </ul>
            </li>
            <li><strong>Non-Poaching</strong>
              <ul>
                <li>Parties agree not to solicit employment from each other’s staff for 24 months post-agreement.</li>
              </ul>
            </li>
            <li><strong>Confidentiality</strong>
              <ul>
                <li>Both parties agree to keep all business-related information confidential.</li>
              </ul>
            </li>
            <li><strong>General</strong>
              <ul>
                <li>No partnership or agency is constituted between the User and the Company.</li>
                <li>Notices to the Company should be emailed to <a href="mailto:info@Nexways.in">info@Nexways.in</a>.</li>
                <li>If any clause is deemed invalid, the remainder of the Agreement remains effective.</li>
              </ul>
            </li>
            <li><strong>Arbitration</strong>
              <ul>
                <li>Disputes will be referred to a sole arbitrator in Vadodara, Gujarat, governed by the Indian Arbitration & Conciliation Act, 1996.</li>
                <li>Proceedings shall be conducted in English.</li>
              </ul>
            </li>
          </ul>
          <ul>
            <li><strong>Limited Liability Clause:</strong>
              <ul>
                <li>The Company and its affiliates are not liable for any direct, indirect, incidental, or consequential damages.</li>
                <li>Liability is limited to the fees paid by the user.</li>
                <li>Disputes between Truck Service Providers and users are governed by the provider's policy.</li>
              </ul>
            </li>
            <li><strong>Grievance Redressal Process:</strong>
              <ul>
                <li>Grievances should be directed to the Grievance Officer at <a href="mailto:info@Nexways.in">info@Nexways.in</a>.</li>
                <li>Provide all necessary details to resolve the issue.</li>
              </ul>
            </li>
            <li><strong>Arbitration:</strong>
              <ul>
                <li>Disputes will be referred to a sole arbitrator appointed by the Company.</li>
                <li>Arbitration proceedings will take place in Vadodara, Gujarat, India.</li>
                <li>The language of arbitration is English.</li>
              </ul>
            </li>
            <li><strong>Force Majeure:</strong>
              <ul>
                <li>The Company is not liable for delays or failures caused by events beyond its control, such as natural disasters, war, or strikes.</li>
              </ul>
            </li>
            <li><strong>Taxes:</strong>
              <ul>
                <li>The user is responsible for all applicable taxes related to transactions.</li>
                <li>The Company is indemnified against tax liabilities imposed on users.</li>
              </ul>
            </li>
            <li><strong>Payment Terms and Refund Policy:</strong>
              <ul>
                <li>Advance booking requires 20% of the payment.</li>
                <li>Out-of-pocket expenses like parking and labor charges must be paid directly by the user.</li>
                <li>Non-payment may result in the retention of consignments until dues are cleared.</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </FrontendLayout>
  )
}
